module.exports = __webpack_public_path__ + "img/and_on.d381883f.png";